import { render } from "./AboutView.vue?vue&type=template&id=11a2679a&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=11a2679a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a2679a"]])

export default __exports__